import { CONTRACT_TYPE, RENTAL_AGREEMENT } from '../../../../shared/constants';
import { IListingDetailForm } from '../ListingDetailForm.types';

export const getRentalAgreementOptions = (values: IListingDetailForm) => {
  if (values?.contract_type?.value === CONTRACT_TYPE['3+2'].value) {
    return [
      {
        label: RENTAL_AGREEMENT.AGREED_FEE.label,
        value: RENTAL_AGREEMENT.AGREED_FEE.value,
      },
    ];
  } else if (values?.contract_type?.value === CONTRACT_TYPE['4+4'].value) {
    return [
      {
        label: RENTAL_AGREEMENT.FREE_FEE.label,
        value: RENTAL_AGREEMENT.FREE_FEE.value,
      },
    ];
  } else if (
    values?.contract_type?.value === CONTRACT_TYPE.TEMPORARY_STUDENT.value
  ) {
    return [
      {
        label: RENTAL_AGREEMENT.AGREED_FEE.label,
        value: RENTAL_AGREEMENT.AGREED_FEE.value,
      },
    ];
  } else if (
    values?.contract_type?.value === CONTRACT_TYPE.TEMPORARY_RENT_TO_RENT.value
  ) {
    return [
      {
        label: RENTAL_AGREEMENT.FREE_FEE.label,
        value: RENTAL_AGREEMENT.FREE_FEE.value,
      },
    ];
  } else {
    return Object.values(RENTAL_AGREEMENT).map(({ label, value }) => ({
      label,
      value,
    }));
  }
};
